/* Stage logic for the narrative animation.
   Stages drive the visibility / position of narrative elements.
   The visual representation is in CSS; this file only describes which
   elements participate at each stage. */

export const FINAL_STAGE = 9;
export const STEP_DURATION_MS = 1800;

/* Stage 9 is a long hold so the LCM ring can spin ~2 full rotations
   before fading back to stage 1. */
export const LOOP_HOLD_MS = 4200;

/* Maps to home.synergyAnimation.stages.s1..s8 (8 storyline captions). */
export const STORYLINE_STAGE: ReadonlyArray<number> = [1, 2, 3, 4, 5, 6, 7, 8];

/* Payload types displayed on the LCM → AI Agent comm line.
   They rotate; one of them is `audit` which triggers stage 8. */
export const AI_AGENT_PAYLOADS = [
  'expiry check',
  'renewal',
  'policy diff',
  'anchor verify',
  'anomaly scan',
  'audit',
] as const;

export type AIAgentPayload = (typeof AI_AGENT_PAYLOADS)[number];

/* Returns the i18n key suffix for the storyline copy at the given stage. */
export const storylineKeyForStage = (stage: number): string | null => {
  if (stage >= 1 && stage <= 8) return `s${stage}`;
  return null;
};

/* Which payload should be active at each stage (used to compute the
   caption shown on the comm line + whether to trigger Audit pulse). */
export const payloadForStage = (stage: number): AIAgentPayload => {
  // stage 6 → first comm, stage 7 → cycling, stage 8 → audit
  if (stage === 8) return 'audit';
  if (stage === 6) return 'expiry check';
  if (stage === 7) return 'renewal';
  return 'expiry check';
};
